import React from "react";
import PropTypes from "prop-types";
import PrimaryLink from "../../elements/primary-link";
import Heading from "../../elements/heading";
import "./style.scss";

const OverviewPromoAppDownload = ({ backgroundImage, heading, qrCode, primaryLink }) => {
  if (!backgroundImage || !qrCode?.src || !heading?.html || !heading?.html?.value) {
    return <></>;
  } else {
    return (
      <div className="overview-promo-app-download">
        <div
          className="background"
          style={{
            backgroundImage: `url(${backgroundImage})`
          }}
        >
          <div className="heading">
            <Heading typographyClass={heading.typographyClass || "type-h4"} type={heading.type} html={heading.html} />
            <div className="app-download-link">
              <PrimaryLink {...primaryLink} />
            </div>
          </div>
          <div className="qr-code">
            <img {...qrCode} />
          </div>
        </div>
      </div>
    );
  }
};

OverviewPromoAppDownload.propTypes = {
  heading: PropTypes.object,
  qrCode: PropTypes.shape({
    src: PropTypes.string
  }),
  primaryLink: PropTypes.object,
  backgroundImage: PropTypes.string
};

export default OverviewPromoAppDownload;
